import { useState } from 'react';
import { View, Text } from 'react-native';
import { Dimensions } from 'react-native';
import theme from '../../theme';
import Button from './Button';
import { LeadCaptureDialog } from './LeadCaptureDialog';

const { width: SCREEN_WIDTH } = Dimensions.get('window');
const isMobile = SCREEN_WIDTH < 760;

const bars = [80, 100, 90, 124, 112, 140, 96];

const Hero = (props) => {

  const submitHandler = props.submitHandler;
  const responseStatus = props.responseStatus;
  const [dialogOpen, setDialogOpen] = useState(false);


  return (
    <View style={{
      flexDirection: isMobile ? 'column' : 'row',
      gap: isMobile ? 32 : 56,
      padding: isMobile ? 32 : 48,
      maxWidth: 1240,
      width: '100%',
      alignSelf: 'center',
    }}>
      {/* Copy column */}
      <View style={{ flex: 1 }}>
        <Text style={{
          alignSelf: 'flex-start',
          fontFamily: theme.typography.fontMono,
          fontSize: theme.typography.size['2xs'],
          letterSpacing: theme.trackingPx(theme.typography.size['2xs'], 'widest'),
          textTransform: 'uppercase',
          color: theme.colors.accentPrimary,
          backgroundColor: theme.colors.brandBlueTint,
          paddingVertical: 4,
          paddingHorizontal: 10,
          borderRadius: theme.radii.full,
          marginBottom: 20,
          overflow: 'hidden',
        }}>
          Conversational analytics
        </Text>

        <Text style={{
          fontFamily: theme.typography.fontDisplay,
          fontWeight: theme.typography.weight.regular,
          fontSize: isMobile ? theme.typography.size['3xl'] : theme.typography.size['4xl'],
          lineHeight: theme.lineHeightPx(isMobile ? theme.typography.size['3xl'] : theme.typography.size['4xl'], 'tight'),
          letterSpacing: theme.trackingPx(theme.typography.size['4xl'], 'tight'),
          color: theme.colors.textPrimary,
          marginBottom: 18,
        }}>
          Talk to your BigQuery tables like a teammate
        </Text>

        <Text style={{
          fontFamily: theme.typography.fontBody,
          fontSize: theme.typography.size.md,
          lineHeight: theme.lineHeightPx(theme.typography.size.md, 'normal'),
          color: theme.colors.textSecondary,
          marginBottom: 30,
          maxWidth: 460,
        }}>
          Type a question. The agent queries your data directly and answers with the right chart, table, or number — no SQL, no dashboard to build first.
        </Text>

        <Button variant="primary" size="lg" onPress={() => setDialogOpen(true)}>Book a demo</Button>
      </View>

      {/* Chat demo card */}
      <View style={{ flex: 1 }}>
        <View style={{
          flex: 1,
          backgroundColor: theme.colors.surfaceCard,
          borderWidth: 1,
          borderColor: theme.colors.borderDefault,
          borderRadius: theme.radii.lg,
          padding: 28,
          gap: 16,
          ...theme.shadows.md,
        }}>
          <Text style={{
            fontFamily: theme.typography.fontMono,
            fontSize: theme.typography.size['2xs'],
            letterSpacing: theme.trackingPx(theme.typography.size['2xs'], 'widest'),
            textTransform: 'uppercase',
            color: theme.colors.textTertiary,
          }}>
            live query
          </Text>

          <Text style={{
            alignSelf: 'flex-end',
            backgroundColor: theme.colors.gray50,
            borderWidth: 1,
            borderColor: theme.colors.borderDefault,
            borderRadius: 10,
            padding: 14,
            fontFamily: theme.typography.fontBody,
            fontSize: theme.typography.size.sm,
            maxWidth: '85%',
          }}>
            Which channel drove the most signups last week?
          </Text>

          <View style={{
            alignSelf: 'flex-start',
            backgroundColor: theme.colors.brandBlueTint,
            borderWidth: 1,
            borderColor: theme.colors.borderDefault,
            borderRadius: 10,
            padding: 16,
            gap: 14,
            maxWidth: '92%',
          }}>
            <Text style={{ fontFamily: theme.typography.fontBody, fontSize: theme.typography.size.sm }}>
              Google Ads drove the most signups — 412 last week (+18% w/w).
            </Text>
            <View style={{ flexDirection: 'row', alignItems: 'flex-end', gap: 8, height: 150 }}>
              {bars.map((h, i) => (
                <View
                  key={i}
                  style={{
                    width: 20,
                    height: h,
                    backgroundColor: i === 5 ? theme.colors.brandBlue : theme.colors.gray300,
                    borderTopLeftRadius: 2,
                    borderTopRightRadius: 2,
                  }}
                />
              ))}
            </View>
          </View>
        </View>
      </View>
      <LeadCaptureDialog visible={dialogOpen} onClose={() => setDialogOpen(false)} onSubmit={submitHandler} responseStatus={responseStatus}/>
    </View>
  );
};

export default Hero;